<template>
  <div class="p-4 bg-white rounded-lg h-100" v-if="isDataLoaded">
    <DataTable
      :table_state="table_state"
      :store_names="store_names"
      :addComponent="componentForAdding"
      :editComponent="componentForEditing"
      :urls="urls"
    />
  </div>
</template>

<script>
import DataTable from "@/own/components/DataTable.vue";
import ActionsDialog from "@/own/components/orderManagement/warehouseAllocationRules/ActionsDialog.vue";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import {
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PER_PAGE,
  SET_TABLE_SORT_BY,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
} from "@/core/services/store/warehouseAllocationRules.module";

export default {
  name: "WarehouseAllocationRules",
  components: { DataTable },
  data: () => ({
    componentForEditing: ActionsDialog,
    componentForAdding: ActionsDialog,
    table_state: {
      UPDATE_TABLE_STRUCTURE: UPDATE_TABLE_STRUCTURE,
      UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
      SET_TABLE_SORTBY: SET_TABLE_SORT_BY,
      SET_TABLE_FILTER: SET_TABLE_FILTER,
      SET_TABLE_PERPAGE: SET_TABLE_PER_PAGE,
      SET_TABLE_PAGE: SET_TABLE_PAGE,
    },
    store_names: {
      getTableFilters: "getWAREHOUSEALLOCATIONRULESTableFilters",
      getTableState: "getWAREHOUSEALLOCATIONRULESTableState",
      getTableData: "getWAREHOUSEALLOCATIONRULESTableData",
      getTableHeaders: "getWAREHOUSEALLOCATIONRULESTableHeaders",
      getTableProperties: "getWAREHOUSEALLOCATIONRULESTableProperties",
      getTablePermissions: "getWAREHOUSEALLOCATIONRULESTablePermissions",
    },
    urls: {
      status: `${process.env.VUE_APP_BASE_URL}/order_management/warehouse_allocation_rules/status`,
    },
  }),
  methods: {
    async initTableContent() {
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_STRUCTURE, {});
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_DATA, {});
    },
  },
  computed: {
    isDataLoaded: function () {
      return this.$store.getters[this.store_names.getTableData];
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.initTableContent();
  },
};
</script>
